if (!customElements.get("sports-shop-by-league")) {
  class SportsShopByLeague extends HTMLElement {
    constructor() {
      super();

      this.attrModalClose = "data-modal-close";
      this.attrModalOverlay = "data-modal-overlay";
      this.attrTab = "data-tab";
      this.attrTabContent = "data-tab-content";
      this.attrModalTrigger = "data-modal-trigger";
      this.attrModalTriggerAll = "data-modal-trigger-all";
      this.classModalOpen = "sports-modal-open";
      this.classTabActive = "sports-teams-modal__tab--active";

      // Text template constants
      this.shopAllText = this.dataset.shopAllText || "Shop all";
      this.modal = document.getElementById("sports-teams-modal");
      this.shopButtons = this.querySelectorAll(`[${this.attrModalTrigger}]`);

      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener("keydown", this.handleEscape);
      document.removeEventListener("click", this.handleClick);
    }

    bindEvents() {
      // Shop button events
      this.shopButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          this.openModal(e.target.dataset.league, e.target.dataset.leagueName);
        });
      });

      // Global event listeners
      document.addEventListener("keydown", this.handleEscape.bind(this));
      document.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      if (!this.modal || this.modal.getAttribute("aria-hidden") !== "false") return;

      const closeBtn = event.target.closest(`[${this.attrModalClose}]`);
      const overlay = event.target.closest(`[${this.attrModalOverlay}]`);
      const tab = event.target.closest(`[${this.attrTab}]`);

      if (closeBtn || overlay) {
        this.closeModal();
      } else if (tab) {
        event.preventDefault();
        this.switchTab(tab.dataset.tab, tab.dataset.leagueName);
      }
    }

    handleEscape(event) {
      if (event.key === "Escape" && this.modal && this.modal.getAttribute("aria-hidden") === "false") {
        this.closeModal();
      }
    }

    openModal(leagueId, leagueName) {
      if (!this.modal) return;

      // Store current scroll position before opening modal
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.top = `-${this.scrollPosition}px`;

      document.body.classList.add(this.classModalOpen);

      this.modal.setAttribute("aria-hidden", "false");
      this.modal.style.display = "block";

      this.switchTab(leagueId, leagueName);
    }

    closeModal() {
      if (!this.modal) return;

      this.modal.setAttribute("aria-hidden", "true");
      this.modal.style.display = "none";

      // Remove modal class and restore scroll position
      document.body.classList.remove(this.classModalOpen);
      document.body.style.top = '';

      // Restore scroll position if it was stored
      if (typeof this.scrollPosition !== 'undefined') {
        window.scrollTo(0, this.scrollPosition);
      }
    }

    switchTab(leagueId, leagueName) {
      if (!this.modal) return;

      const tabs = this.modal.querySelectorAll(`[${this.attrTab}]`);
      const tabContents = this.modal.querySelectorAll(`[${this.attrTabContent}]`);
      const viewAllButtons = this.modal.querySelectorAll(`[${this.attrModalTriggerAll}]`);

      // Find the selected tab to get its URL phrase
      let selectedTab = this.modal.querySelector(`[${this.attrTab}="${leagueId}"]`);

      // Fallback to first tab if not found
      if (!selectedTab) {
        selectedTab = tabs[0];
      }

      const shopAllUrlPhrase = selectedTab ? selectedTab.dataset.shopAllUrlPhrase : null;

      // Update view all buttons text and URLs
      viewAllButtons.forEach((button) => {
        button.textContent = `${this.shopAllText} ${leagueName}`;
        if (shopAllUrlPhrase && shopAllUrlPhrase.trim() !== '') {
          button.href = `/pages/league/${shopAllUrlPhrase}`;
        } else {
          button.href = '#';
        }
      });

      // Remove active states and hide all content
      tabs.forEach((tab) => tab.classList.remove(this.classTabActive));
      tabContents.forEach((content) => content.style.display = "none");

      let selectedContent = this.modal.querySelector(`[${this.attrTabContent}="${leagueId}"]`);
      if (!selectedContent) {
        selectedContent = tabContents[0];
      }

      if (selectedTab) selectedTab.classList.add(this.classTabActive);
      if (selectedContent) selectedContent.style.display = "block";
    }
  }

  customElements.define("sports-shop-by-league", SportsShopByLeague);
}